import { Formik, FormikConfig, FormikProps } from 'formik';
import { FV } from './share';
import { ReactNode } from 'react';
import FormContent, { FormContentProps } from './FormContent';

export interface PolicyFormProps extends FormikConfig<FV>, FormContentProps {
  children: (form: ReactNode, props: FormikProps<FV>) => ReactNode;
}

function TodoPolicyForm(props: PolicyFormProps) {
  const { header, footer, readonly, defaultActiveRegion, children, ...otherProps } = props;

  return (
    <Formik enableReinitialize validateOnMount {...otherProps}>
      {(props) =>
        children(
          <FormContent
            header={header}
            footer={footer}
            readonly={readonly}
            defaultActiveRegion={defaultActiveRegion}
          />,
          props,
        )
      }
    </Formik>
  );
}

export default TodoPolicyForm;
